import React from 'react';
import { FiUsers } from 'react-icons/fi';
import { normalizeInstagramCollaborators } from './instagramCollaboration';
import './InstagramCollaborators.css';

export default function InstagramCollaborators({ value, onChange, contentFormats = [], disabled = false }) {
  const storyOnly = contentFormats.length > 0 && contentFormats.every((format) => format === 'story' || format === 'text');
  let error = '';
  let count = 0;
  try { count = normalizeInstagramCollaborators(value).length; } catch (problem) { error = problem.message; }
  return (
    <section className="instagram-collaboration" aria-labelledby="instagram-collaboration-title">
      <div className="instagram-collaboration-heading"><FiUsers /><strong id="instagram-collaboration-title">Invite Collaborators</strong><small>{count ? `${count} / 3` : 'Optional'}</small></div>
      <label htmlFor="instagram-collaborators">Invite collaborators</label>
      <input id="instagram-collaborators" value={value} disabled={disabled} maxLength={200}
        aria-invalid={Boolean(error || (storyOnly && value))} aria-describedby="instagram-collaborators-help"
        onChange={(event) => onChange(event.target.value)} placeholder="@username, @another_username" autoComplete="off" spellCheck={false} />
      <small id="instagram-collaborators-help">{error || (storyOnly ? 'Collaboration requires a feed image or Reel. Story and text-only posts are not supported.' : 'Up to 3 usernames. Invitations are requested when the Instagram post publishes; each collaborator must accept. Scheduled posts send invitations only when published. Stories are excluded.')}</small>
    </section>
  );
}
